import { askLocation } from '@/utils/geolocation';
import QrMenuApi from "@/services/qrmenu-api";

export const namespaced = true;

export const state = {
  location: null,
  locationError: null,
  locationLoading: false,
  gpsLocalizationValid: {}
};

export const mutations = {
  SET_LOCATION(state, location) {
    state.location = location;
  },
  SET_LOCATION_ERROR(state, error) {
    state.locationError = error;
  },
  SET_GPS_STATUS(state, status) {
    state.gpsLocalizationValid = status;
  },
  SET_LOCATION_LOADING(state, isLoading) {
    state.locationLoading = isLoading;
  }
};

let locationIntervalId = null;

export const actions = {

    startPeriodicLocationFetch({ dispatch }) {
        if (locationIntervalId) {
        clearInterval(locationIntervalId);
        }

        dispatch('fetchLocationWithGpsStatus');

        locationIntervalId = setInterval(() => {
        dispatch('fetchLocationWithGpsStatus');
        }, 30000);
    },

    stopPeriodicLocationFetch() {
        if (locationIntervalId) {
        clearInterval(locationIntervalId);
        locationIntervalId = null;
        }
    },

    async fetchLocation({ commit }) {
        commit('SET_LOCATION_LOADING', true);

        try {
        const location = await askLocation();
        commit('SET_LOCATION', location);
        commit('SET_LOCATION_ERROR', false);
        return location;
        } catch (error) {
        commit('SET_LOCATION_ERROR', true);
        commit('SET_LOCATION', null);
        throw error;
        } finally {
        commit('SET_LOCATION_LOADING', false);
        }
    },

    async fetchLocationWithGpsStatus({ dispatch }) {
        const location = await dispatch('fetchLocation');
        if (location) {
        await dispatch('fetchGpsStatus');
        }
        return location;
    },


    async fetchGpsStatus({ state, commit }) {

    if (!state.location) {
        return null;
    }

    const url = new URL(window.location.href);

    const pathSegments = url.pathname.split('/');
    const menuCode = pathSegments[pathSegments.length - 1];

    const tid = url.searchParams.get('tid');        
    const did = url.searchParams.get('did');
    const ts = url.searchParams.get('ts');

    if (!menuCode || !tid || !ts) {
        return null;
    }

    try {
        const result = await QrMenuApi.getGpsStatus(
        menuCode,
        state.location.latitude,
        state.location.longitude,
        ts,
        tid,
        did
        );
        commit('SET_GPS_STATUS', result);
        return result;
    } catch (error) {
        commit('SET_GPS_STATUS', null);
        throw error;
    }
    }

};

export const getters = {
  coords: (state) => state.location,
  coordsError: (state) => state.locationError,
  gpsLocalizationValid: (state) => state.gpsLocalizationValid,
  locationLoading: (state) => state.locationLoading
};
